module.exports = __webpack_public_path__ + "img/Store_Desktop.jpg";